<template>
  <v-container>
    <v-card min-width="350px" class="mt-10 rounded-xl" :loading="loading">
      <v-card-title class="d-flex justify-center">
        <span class="headline"> {{ post.title }} </span>
      </v-card-title>
      <v-card-text>
        <div v-html="post.content">
          {{ post.content }}
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <!-- <v-btn icon>
          <v-icon> mdi-heart </v-icon>
        </v-btn>
        <v-icon> mdi-eye </v-icon>
        {{ post.seen_count }} -->
      </v-card-actions>
    </v-card>
    <br />
  </v-container>
</template>

<script>
import openapi from "../config/openapi";

export default {
  data: () => ({
    url: "/api/v1/posts/",
    post: null,
    loading: true,
  }),

  methods: {
    getPost: function () {
      let post_id = this.$route.params.post_id;
      let target_url = this.url + post_id + "/";
      // console.log(target_url);
      openapi
        .get(target_url)
        .then((response) => {
          this.post = response.data;
          // console.log("Response:" + response.data.title);
          //   this.loading = false;
        })
        .catch((error) => {
          console.log(error.data);
        });
    },
  },
  created() {
    // this.loading = true;
    this.getPost();
    // console.log("Loaded");
    this.loading = false;
  },
};
</script>